export default "__VITE_ASSET__DdcoZrJv__"